<template>
  <div class="end">
    <div class="end__zw"></div>
    <img class="end__title" src="../../assets/images/end_title1.png" alt="" />
    <img class="end__title2" src="../../assets/images/end_title2.png" alt="" />
    <img
      class="end__btn"
      @click="showLoginPop = true"
      src="../../assets/images/end_btn.png"
      alt=""
    />
  </div>
</template>
<script setup>
import { ref } from "vue";
import { useRouter } from "vue-router";
const showLoginPop = ref(false);
const router = useRouter();
router.push({ name: "Login" });
</script>
<style lang="scss" scoped>
.end {
  width: 100vw;
  height: 100vh;
  background-image: url("../../assets/images/login_bg.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  position: relative;
  &__zw {
    width: 100%;
    height: 168px;
  }
  &__title {
    width: 300px;
    height: auto;
  }

  &__title2 {
    width: 331.5px;
    height: auto;
    margin: 0;
    padding: 0;
    display: block;
    margin-left: auto;
    margin-right: auto;
    margin-top: 38px;
  }
  &__btn {
    width: 190px;
    height: auto;
    margin: 0;
    padding: 0;
    display: block;
    margin-left: auto;
    margin-right: auto;
    margin-top: 90.5px;
  }
}
</style>
